import { UserApiService, UserDetails } from '@api/user';
import { Component, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Event, NavigationEnd, Router } from "@angular/router";
import { NbDialogRef, NbDialogService, NbSidebarService, NbToastrService } from '@nebular/theme';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { environment } from '@environment/environment';

@Component({
  selector: "bf-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent {
  @ViewChild('dialog', { read: TemplateRef, static: false }) dialogPatient: TemplateRef<any>;

  title: string;
  breadcrumbs: any[] = [];
  actions = [];
  list = environment.brand === 'antrosport'
    ? ['Mi perfil', 'Cambiar clave', 'Descargar Tutorial Soft', 'Cerrar sesión']
    : ['Mi perfil', 'Cambiar clave', 'Cerrar sesión'];
  actionsControl = new FormControl();
  actionsForm: FormGroup;
  changePasswordForm: FormGroup;
  dialogRef: NbDialogRef<any>;
  successMessage: boolean = false;
  showPassword: boolean = false;
  showRepeatPassword: boolean = false;
  showOldPassword: boolean = false;
  changePasswordError: string = '';
  user: UserDetails;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sidebarService: NbSidebarService,
    private userApi: UserApiService,
    private toastrService: NbToastrService,
    _fb: FormBuilder,
    private dialogService: NbDialogService,

  ) {
    this.user = this.userApi.getUser();
    this.actionsForm = _fb.group({
      menu: this.actionsControl
    })
    this.changePasswordForm = _fb.group({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6)
      ]),
      oldPassword: new FormControl('', Validators.required),
      repeatPassword: new FormControl('', Validators.required),
    }, { validator: this.passwordFormValidator });

    this.changePasswordForm.valueChanges.subscribe(d => {
      this.changePasswordForm.errors
    })
    this.router.events.subscribe((e: Event) => this.getCurrentPageData(e));

    this.actionsControl.valueChanges.subscribe(data => {
      if (data === 'Cerrar sesión') {
        this.logOut();
        this.actionsForm.reset();
      } if (data === 'Cambiar clave') {
        this.openChangePassword();
        this.actionsForm.reset();
      }
      if (data === 'Mi perfil') {
        this.router.navigate(['/admin/perfil/mi-perfil']);
        this.actionsForm.reset();
      }
      if (data === 'Descargar Tutorial Soft') {
        this.descargarPDF();
        this.actionsForm.reset();
      }
    })
  }

  passwordFormValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const oldPassword = control.get('oldPassword');
    const password = control.get('password');
    const repeatPassword = control.get('repeatPassword');

    const errors: { [key: string]: boolean } = {};

    if (password && repeatPassword && password.value !== repeatPassword.value) {
      errors.passwordMismatch = true;
    }

    if (oldPassword && password && oldPassword.value && password.value && oldPassword.value === password.value) {
      errors.passwordSameAsOld = true;
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    }

    return null;
  }

  getCurrentPageData(e: Event) {
    if (e instanceof NavigationEnd) {
      const items = this.getRouteItems();
      const current = items[items.length - 1];
      if (current && current.data) {
        if (current.data.title == "Reportes" && e.url.includes("plan-prearmado-report"))
          this.title = "Planes de Alimentación";
        else
          this.title = current.data.title;
        this.actions = current.data.actions;
        this.breadcrumbs = items.map((value: RouteItem) => {
          return {
            name: value.data.breadcrumb,
            path: value.path,
          };
        });
      }
    }
  }

  private getRouteItems(): RouteItem[] {
    const result: RouteItem[] = [];
    let child = this.route.snapshot.firstChild;
    let route = "";
    while (child) {
      if (child.data && (child.data.title || child.data.breadcrumb)) {
        if (child.url.length > 0) {
          route += `/${child.url.toString()}`;
        }
        if (child.component) {
          result.push(<RouteItem>{
            path: route,
            data: <RouteItemData>{
              title: child.data["title"],
              actions: child.data["actions"] as RouteActions[],
              breadcrumb: child.data["breadcrumb"],
            },
          });
        }
      }
      if (child.firstChild) {
        child = child.firstChild;
      } else {
        break;
      }
    }
    return result;
  }

  public toggleSidebar(): void {
    this.sidebarService.toggle();
  }

  public logOut() {
    this.userApi.logOut();
    this.router.navigate(['/'])
  }

  openChangePassword() {
    this.successMessage = false;
    this.changePasswordError = '';
    this.changePasswordForm.reset();
    this.dialogRef = this.dialogService.open(this.dialogPatient);
  }

  descargarPDF() {
    const url = 'assets/tutorial-soft.pdf';
    const link = document.createElement('a');
    link.href = url;
    link.download = 'tutorial-soft.pdf';
    link.target = '_blank';
    link.click();
  }

  isChangingPassword = false;

  changePassword() {
    if (this.changePasswordForm.invalid || this.isChangingPassword) {
      return;
    }
    this.isChangingPassword = true;
    this.changePasswordError = '';
    this.userApi.changePassword(
      this.changePasswordForm.get('password').value,
      this.changePasswordForm.get('oldPassword').value,
    )
      .subscribe(
        data => {
          this.isChangingPassword = false;
          this.successMessage = true;
        },
        error => {
          this.isChangingPassword = false;
          const msg = error?.error?.userMessage || error?.error?.message || error?.error?.exMessage || 'Error al cambiar la contraseña, revise los datos ingresados';
          this.changePasswordError = msg;
        }
      )
  }
  goHome(): void {
    if (this.user.roles === 'ROLE_PATIENT' || this.user.roles === 'ROLE_BACKOFFICE') {


    } else {
      this.router.
        navigateByUrl('admin/patient')
    }
  }
  navigate() {
    this.successMessage = false;
    this.isChangingPassword = false;
    this.changePasswordError = '';
    this.changePasswordForm.reset();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowRepeatPassword() {
    this.showRepeatPassword = !this.showRepeatPassword;
  }

  toggleShowOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }

  get passwordStrength(): { level: number; label: string; color: string } {
    const password = this.changePasswordForm?.get('password')?.value || '';
    if (!password) return { level: 0, label: '', color: '' };

    let score = 0;
    if (password.length >= 6) score++;
    if (password.length >= 10) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score <= 1) return { level: 1, label: 'Débil', color: '#dc3545' };
    if (score <= 2) return { level: 2, label: 'Regular', color: '#fd7e14' };
    if (score <= 3) return { level: 3, label: 'Buena', color: '#ffc107' };
    if (score <= 4) return { level: 4, label: 'Fuerte', color: '#28a745' };
    return { level: 5, label: 'Muy fuerte', color: '#218838' };
  }
}

class RouteItem {
  path: string;
  data: RouteItemData;
}

class RouteItemData {
  title: string;
  actions?: RouteActions[];
  breadcrumb?: string;
}

class RouteActions {
  icon: string;
  route: string;
  text: string;
}
